import type { IconSvgObject } from './types';

const Tv02Icon: IconSvgObject = [
  ["path", { d: "M19 3H5C3.34315 3 2 4.34315 2 6V16C2 17.6569 3.34315 19 5 19H19C20.6569 19 22 17.6569 22 16V6C22 4.34315 20.6569 3 19 3Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18 19L19 21M6 19L5 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Tv02Icon;
